<template>
  <div class="col">
    <div class="row mb-4 sticky-top sectionOverview">
      <SectionOverview />
    </div>
    <template v-for="configGroupId in configGroups">
      <div class="row mb-4 config-group-row" :id="createConfigGroupElementId(configGroupId)">
        <ConfigGroup :config-group="configGroupId" />
      </div>
    </template>
  </div>
  <div class="col-lg-4 col-sm-12 d-lg-block d-none" v-if="!configuratorOverviewTargetElement">
    <ConfigurationOverview :is-sticky="true" />
  </div>
  <template v-if="configuratorOverviewTargetElement">
    <Teleport :to="configuratorOverviewTargetElement">
      <ConfigurationOverview :is-sticky="true" />
    </Teleport>
  </template>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "vue";
import ConfigGroup, {createConfigGroupElementId} from "components/ConfigGroup";
import ConfigurationOverview from "components/ConfigurationOverview";
import SectionOverview from "components/SectionOverview";

export default {
  name: "ProductConfigurator",
  components: {SectionOverview, ConfigurationOverview, ConfigGroup},
  setup() {
    const store = useStore();

    return {
      createConfigGroupElementId,

      configGroups: computed(() => store.state.sortOrders.articleConfigGroups),
      configuratorOverviewTargetElement: store.state.options.configuratorOverviewTargetElement,
      article: computed(() => store.state.article),
    }
  }
}
</script>

<style scoped>
.config-group-row {
  scroll-margin-top: 105px;
}

.config-group-row:last-child {
  margin-bottom: 0 !important;
}

.sectionOverview {
  z-index: 1;
  position: sticky;
  top: 0;
}
</style>